/* eslint-disable */
export type BreakpointLabel = 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

export type Breakpoints<T> = {
  [label in BreakpointLabel]: T;
};

type BreakpointStylesMappingFunction<T> = (bp: BreakpointLabel) => T;
type BreakpointStyles<T> = {
  [style: string]: Partial<Breakpoints<T> | BreakpointStylesMappingFunction<T>>;
};

export const responsiveStyles = <T extends Record<string, Partial<Breakpoints<T>>>>(
  styles: BreakpointStyles<T>,
  breakpoints: Breakpoints<number>,
) => {
  // Create a mapping of breakpoint -> style declarations
  const breakpointMap: Partial<Record<BreakpointLabel, Record<string, T>>> = {};

  for (const [styleProp, values] of Object.entries(styles)) {
    const typedValues = values as Partial<Breakpoints<T>>;
    for (const [bp, val] of Object.entries(typedValues) as [BreakpointLabel, T][]) {
      if (!breakpointMap[bp]) {
        breakpointMap[bp] = {};
      }
      breakpointMap[bp]![styleProp] = val;
    }
  }
  // Sort breakpoints and generate CSS
  return Object.entries(breakpointMap)
    .sort(([a], [b]) => breakpoints[a as BreakpointLabel] - breakpoints[b as BreakpointLabel])
    .map(([bp, styles]) => {
      const minWidth = breakpoints[bp as BreakpointLabel];
      const declarations = Object.entries(styles!)
        .map(([prop, value]) => `${prop}:${value};`)
        .join('');
      return `@media (min-width:${minWidth}px){${declarations}}`;
    })
    .join('');
};
